import { THOUSAND_ONE, PERCENT_TOW, FLOAT_ONE, FLOAT_TOW } from './constant';
import { formatPrice } from '@/common/utils';
const numberFormate = (num) => {
  let reg = /\B(?=(\d{3})+$)/g;
  return String(num).replace(reg, ',');
};
/**
 *
 * @param  key 指标名称
 * @param  num 指标值
 * @param  type 数据来源类型，如指标''、趋势图trend
 * @returns
 */
const NumberFormate = (key, num, type = '') => {
  if (THOUSAND_ONE.includes(key)) {
    return type == 'trend' ? num.toFixed(1) : numberFormate(num.toFixed(1));
  } else if (PERCENT_TOW.includes(key)) {
    let date = String(num * 100);
    return type == 'trend' ? num.toFixed(4) : formatPrice(date, undefined, undefined, '%');
  } else if (FLOAT_ONE.includes(key)) {
    return type == 'trend' ? num.toFixed(1) : numberFormate(num.toFixed(1));
  } else if (FLOAT_TOW.includes(key)) {
    return type == 'trend' ? num.toFixed(2) : numberFormate(num.toFixed(2));
  } else {
    return type == 'trend' ? Math.abs(Math.floor(num)) : numberFormate(Math.abs(Math.floor(num)));
  }
};

export default NumberFormate;
